import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {
    MultiSetsMulticampaignPromotionStates,
    MultiSetsMulticampaignPromotionModuleEvents,
    MultiSetsMulticampaignPromotionModule,
} from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionInProgressSpinningState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents
> {
    public onEnterState(): void {}
    public onLeaveState(): void {}

    protected setupEvents(): void {
        this.setEventHandler(LogicEvents.BALANCE_UPDATED, this.update.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.update.bind(this));
        this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.onPaidRoundEnded.bind(this));
    }

    protected update(): void {
        this.module.updateCounter();

        if (this.module.getPromotion().isLastPromotion()) {
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.LAST_PROMOTION);
        }
    }

    protected onPaidRoundEnded(): void {
        this.module.gotoState(MultiSetsMulticampaignPromotionStates.IN_PROGRESS);
    }
}
